module.exports = __webpack_public_path__ + "img/equipment-status.8ce1fee6.svg";